import {createSinglePathSVG} from './TEMPLATE'

export const Underline_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M15 3.33333V9.16667C15 11.9281 12.7614 14.1667 10 14.1667C7.23858 14.1667 5 11.9281 5 9.16667V3.33333M3.33333 17.5H16.6667',
})
